import React from 'react'
import { get } from 'lodash'
import brands from '../../configuration/brands'
import VirtualTourArrowButton from '../elements/VirtualTourArrowButton'
import renderDiscountLabels from './renderDiscountLabels'
import formatPrice from '../../utils/formatPrice'
import TaxLine from '../TaxLine'
import Price from '../Price'

function renderStateRoomTitle(stateRoom, roomData, isSuperCategory, brand) {
  let title = roomData.name
    ? roomData.name
    : stateRoom.stateRoomDescription
    ? stateRoom.stateRoomDescription
    : brands[brand].stateRooms[stateRoom.superCategoryCode].title

  if (isSuperCategory) {
    return title
  } else {
    return stateRoom.stateroomCategoryCode
      ? `${title} ${stateRoom.stateroomCategoryCode}`
      : title
  }
}

function renderImageSrc(images, brand, superCategoryCode) {
  if (images && images[0] && images[0].sizes) {
    if (images[0].sizes[`stateroom_${brand.toLowerCase()}`]) {
      return images[0].sizes[`stateroom_${brand.toLowerCase()}`]
    }
    if (images[0].sizes.staterooms && images[0].sizes.staterooms) {
      return images[0].sizes.staterooms
    }
  }

  if (images && images[0] && images[0].file) {
    return images[0].file
  }
  return brand
    ? brands[brand.toUpperCase()].stateRoomImages[superCategoryCode]
    : null
}

const StateRoomCard = props => {
  const {
    stateRoom,
    imgHeight,
    brand,
    isCarouselView,
    qualifiers,
    currency,
    currencySymbol,
    currencySymbolPlacement,
    openVirtualTour,
    brandClassName
  } = props

  const roomData = stateRoom.isSuperCategory
    ? stateRoom.superCategoryData
    : stateRoom.stateroom
  const stateRoomImage = renderImageSrc(
    roomData.image,
    brand,
    stateRoom.superCategoryCode
  )
  const imgWidth = (imgHeight / stateRoomImage.height) * stateRoomImage.width

  const { promos, isSuperCategory, isRefundable } = stateRoom

  let virtualTourLink, virtualTourText

  if (isSuperCategory) {
    virtualTourLink = get(
      stateRoom,
      'superCategoryData.virtual_tour_button_link',
      null
    )
    virtualTourText = get(
      stateRoom,
      'superCategoryData.virtual_tour_button_text',
      null
    )
  } else {
    virtualTourLink = get(stateRoom, 'stateroom.virtual_tour_button_link')
    virtualTourText = get(stateRoom, 'stateroom.virtual_tour_button_text', null)
  }

  const discountLabels = renderDiscountLabels(qualifiers, promos)

  const title = renderStateRoomTitle(
    stateRoom,
    roomData,
    isSuperCategory,
    brand.toUpperCase()
  )

  const taxes = get(stateRoom, 'priceInfo.taxesFees')
  const isBundlePricing = get(stateRoom, 'priceInfo.taxesFeesIncluded', false)

  return (
    <div className="equote__package-details-state-room-wrapper">
      <div className="equote__package-details-state-room">
        <div className="equote__package-details-state-room--header stateroom-carousel-only">
          <div className="equote__package-details-state-room--header--title">
            <p className="u-remove-margin">{title}</p>
          </div>
          {virtualTourLink && virtualTourLink.length > 0 ? (
            <div
              className={`equote__package-details-state-room--virtual-tour-trigger ${brandClassName}`}
            >
              <VirtualTourArrowButton
                onClick={() =>
                  openVirtualTour({
                    link: virtualTourLink,
                    title: virtualTourText || 'Virtual Tour'
                  })
                }
                text={virtualTourText || 'Virtual Tour'}
                brandClassName={brandClassName}
              />
            </div>
          ) : null}
        </div>
        <div
          className="equote__package-details-state-room--image-container"
          style={{
            width: !isCarouselView
              ? imgWidth > 1
                ? imgWidth
                : imgHeight
              : '100%',
            height: !isCarouselView ? imgHeight : 'auto'
          }}
        >
          <img
            alt={roomData.name}
            src={stateRoomImage.src}
            className="equote__package-details-state-room--image-container-picture"
          />
        </div>
        <div className="equote__package-details-state-room--image-container print-only">
          <img alt={roomData.name} src={stateRoomImage.src} />
        </div>
        <div className="equote__package-details-state-room--body">
          <div className="equote__package-details-state-room--body--section">
            <div className="equote__package-details-state-room--header stateroom-desktop-only">
              <div className="equote__package-details-state-room--header--title">
                <p className="u-remove-margin">{title}</p>
              </div>
              {virtualTourLink && virtualTourLink.length > 0 ? (
                <div
                  className={`equote__package-details-state-room--virtual-tour-trigger ${brandClassName}`}
                >
                  <VirtualTourArrowButton
                    onClick={() =>
                      openVirtualTour({
                        link: virtualTourLink,
                        title: virtualTourText || 'Virtual Tour'
                      })
                    }
                    text={virtualTourText || 'Virtual Tour'}
                    brandClassName={brandClassName}
                  />
                </div>
              ) : null}
            </div>
            <div className="equote__package-details-state-room--body--section-details">
              <div className="equote__package-details-state-room--pricing">
                <table className="equote__package-details-state-room--pricing--prices">
                  <thead>
                    <tr>
                      <td>Price from...</td>
                      <td>
                        {!isRefundable && (
                          <span className="equote__package-details-state-room--pricing--header-non-refundable-flag">
                            *NON-REFUNDABLE DEPOSIT
                          </span>
                        )}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {stateRoom && Object.values(stateRoom.pricing || {}).length
                      ? Object.values(stateRoom.pricing).map((price, i) => (
                          <tr
                            key={price.displayName + i}
                            className="equote__package-details-state-room--pricing--prices-price"
                          >
                            <td className="equote__package-details-state-room--pricing--prices-price--name">
                              {price.displayName}
                            </td>
                            <td className="equote__package-details-state-room--pricing--prices-price--amount">
                              <strong>
                                <Price
                                  price={formatPrice(price.displayPrice)}
                                  currencySymbol={currencySymbol}
                                  currencySymbolPlacement={
                                    currencySymbolPlacement
                                  }
                                />{' '}
                                {currency}
                              </strong>
                              <span className="equote__package-details-state-room--pricing--prices-price--promo">
                                {price.leadPromoDesc
                                  ? price.leadPromoDesc
                                  : null}{' '}
                                {price.creditAmt
                                  ? `${currencySymbol || '$'}${
                                      price.creditAmt
                                        ? price.creditAmt.toFixed(2)
                                        : ''
                                    } OBC`
                                  : null}
                              </span>
                            </td>
                          </tr>
                        ))
                      : '-'}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!!discountLabels.length && (
        <div className="state-room-disclaimers">
          {discountLabels.map(discount => (
            <p>{discount}</p>
          ))}
        </div>
      )}
      {
        <p className="state-room-taxes">
          <i>
            <TaxLine
              isBundlePricing={isBundlePricing}
              currencySymbol={currencySymbol}
              currencySymbolPlacement={currencySymbolPlacement}
              amount={taxes}
              currency={currency}
            />
          </i>
        </p>
      }
    </div>
  )
}

export default StateRoomCard
